<template>
    <div class="py-4">
        <p class="text-gray-900">
            <strong class="font-bold">{{ $t('investment_process.vermanlg.vermanlg_right_of_withdrawal') }}</strong>
        </p>
        <p class="text-gray-500">
            {{
                $t('investment_process.vermanlg.vermanlg_right_of_withdrawal_disclaimer', {
                    asset_title: asset_title,
                })
            }}
        </p>
    </div>
</template>

<script setup lang="ts">
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'

const { asset_title } = getCampaignData().asset_data
</script>

<style scoped></style>
